import React from "react";
import { kgInspectorIcons } from "../../kg/canvas/inspector/kgInspectorIcons";
import { KgInspectorDataGrid } from "../KgInspectorDataGrid";
import { KgInspectorNavLinkButton } from "../../atoms/KgInspectorNavLinkButton";
import { KgInspectorTwoLineCell } from "../../atoms/KgInspectorTwoLineCell";
import {
  CountBadge,
  EmptyHint,
  IconSlot,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "./KgInspectorRelationshipTab.styles";
import type { KgInspectorRelationshipTabProps } from "./KgInspectorRelationshipTab.types";

const RelationshipIcon = kgInspectorIcons.relationship;

const DEFAULT_EMPTY_HINT = "No relationships defined for this table yet.";

export const KgInspectorRelationshipTab: React.FC<
  KgInspectorRelationshipTabProps
> = ({ relationships = [], pairs, emptyHint = DEFAULT_EMPTY_HINT }) => {
  const rowCount = pairs ? pairs.length : relationships.length;

  return (
    <TabRoot>
      <SectionHeader>
        <IconSlot>
          <RelationshipIcon size={16} />
        </IconSlot>
        <SectionTitle>Relationships</SectionTitle>
        {rowCount > 0 && <CountBadge>{rowCount}</CountBadge>}
      </SectionHeader>

      {rowCount === 0 ? (
        <EmptyHint>{emptyHint}</EmptyHint>
      ) : pairs ? (
        // Two-line pair layout (Figma 2745-38725) — shared drawer design.
        <KgInspectorDataGrid
          rows={pairs}
          rowKey={(row) => row.id}
          columns={[
            {
              key: "fromTable",
              header: "TABLE",
              width: "flex",
              render: (row) => (
                <KgInspectorTwoLineCell
                  primary={row.from.name}
                  secondary={row.from.column}
                />
              ),
            },
            {
              key: "relationship",
              header: "RELATIONSHIP",
              width: "flex",
              render: (row) => (
                <KgInspectorTwoLineCell
                  primary={row.relationType}
                  secondary={row.cardinality}
                />
              ),
            },
            {
              key: "toTable",
              header: "TABLE",
              width: "flex",
              render: (row) => (
                <KgInspectorTwoLineCell
                  primary={row.to.name}
                  secondary={row.to.column}
                />
              ),
            },
          ]}
        />
      ) : (
        <KgInspectorDataGrid
          rows={relationships}
          rowKey={(row) => row.id}
          columns={[
            {
              key: "table",
              header: "TABLE",
              width: "flex",
              render: (row) => <KgInspectorNavLinkButton link={row.tableLink} />,
            },
            {
              key: "column",
              header: "COLUMN",
              width: "flex",
              render: (row) => row.columnName,
            },
            {
              key: "relationType",
              header: "RELATION TYPE",
              width: "flex",
              render: (row) => row.relationType,
            },
          ]}
        />
      )}
    </TabRoot>
  );
};

export default KgInspectorRelationshipTab;
